<template>
  <div class="form-group with-icon-left">
    <div class="input-group">
      <input
        onpaste="return false;"
        autocomplete="off"
        id="input-icon-left"
        name="input-icon-left"
        @keyup="doFilter()"
        v-model="filterText"
        required
      >
      <i class="glyphicon glyphicon-search icon-left input-icon search-icon"></i>
      <label class="control-label" for="input-icon-left">{{'Pretraga'}}</label>
      <i class="bar"></i>
    </div>
    <div>
      <span id="download-icon" class="fa fa-download icon-left" @click.prevent="DownloadExcel()" style="font-size:16px;color:green"></span>
    </div>
    <div id="Upload" class="div-updwn">
      
      <assay-file-upload
          :file-types="'.xls, .xlsx, .xlsb'" 
          type="single"
          v-model="single">
     </assay-file-upload>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { bus } from "../../../../main";
import { http } from "../../../../../config/config.js";
import AssayFileUpload from "../upload/AssayFileUpload.vue";
Vue.component("assay-file-upload", AssayFileUpload);


export default {
  name: "filterBar",
  components: {
    AssayFileUpload,

  },
  data() {
    return {
      filterText: "",
      single:[]
    };
  },
  mounted() {
    bus.$on("SetFilterFromLabAssay", data => {
      if (this.filterText != data) {
        this.filterText = data;
        this.doFilter(this.filterText);
      }
    });
  },
  beforeDestroy() {
    bus.$off("SetFilterFromLabAssay");
  },
  methods: {
    doFilter() {
      this.$emit("filter", this.filterText);
      bus.$emit("SetFilterFromAnaAssay", this.filterText);
    },
    DownloadExcel(){
      console.log("Download excel")
      function msToTime(duration) {
            const month   = duration.getMonth() + 1; 
            const day     = duration.getDate();
            const year    = duration.getFullYear();
            return day + "-" + month + "-" + year
          }
                http
            .get(
              "assays/references/download?token=" +
                this.$store.state.token +
                "&site=" +
                this.$store.state.site+
                 "&sekcija=ALL" ,//+this.$store.state.inventar.sekcija
              { responseType: "blob" }
            )
            .then((res) => {
              console.log(res);
              if (res.status == 200) {
                console.log('response received')
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "OBR-Referentne_"+msToTime(new Date())+ ".xlsx");
                document.body.appendChild(link);
                link.click();
              }
            });
    },
  }
};
</script>

<style lang="scss" scoped>
.search-icon {
  transform: rotate(90deg);
}

.form-group {
  min-width: 7rem;
}

@media (max-width: 768px) {
  .form-group {
    width: 80%;
  }
}
#Download {
  position: relative;
}
#Upload {
  position: relative;
}
.div-dwnup{
  left: 40%;
}
.div-updwn{
  left: 100%;
}
.download-icon{
  left: 100%;
}
.upload-icon{
  left: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/anaassays/vuestic-datatable/datatable-components/FilterBar.vue